import React, { FC, useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { SIDE } from "_constants";
import { getTeamColors } from "components/colors";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { MatchStatus } from "service";

const ANIMATION_DURATION = 5000;

export const GoalIndicator: FC<{
  side: SIDE;
  teamName: string;
  onEnd: () => void;
  status?: MatchStatus;
}> = ({ side, teamName, onEnd, status }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    const timer = setTimeout(() => {
      setVisible(false);
      onEnd();
    }, ANIMATION_DURATION);
    return () => clearTimeout(timer);
  }, [onEnd]);

  if (!visible) return null;

  const { home, away } = getTeamColors(status as any);
  const backgroundColor = side === SIDE.HOME ? home : away;

  return (
    <GoalContainer side={side} backgroundColor={backgroundColor}>
      <DotLottieReact
        src="https://lottie.host/b73bfd7d-fd6c-410d-a582-75c440b9e2fe/n6N1irHsOZ.lottie"
        loop
        autoplay
        style={{ width: "70%", height: "70%" }}
      />
      <TeamName className="text-outline">{teamName}</TeamName>
    </GoalContainer>
  );
};

const moveRight = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(0%); }
`;

const moveLeft = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0%); }
`;

const GoalContainer = styled.div<{ side: SIDE; backgroundColor: string }>`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  background-color: ${({ backgroundColor }) => backgroundColor};
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  z-index: 99999;
  animation: ${(p) => (p.side === SIDE.HOME ? moveRight : moveLeft)} 3s ease;
`;

const TeamName = styled.div`
  margin-top: 1vw;
  text-transform: uppercase;
  text-align: center;
  display: flex;
  justify-content: center;
  color: #fff;
  font-size: 6vw;
  font-weight: 800;
`;
